// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".box{border:1px solid hsla(0,0%,100%,.35);box-shadow:0 0 12px rgba(0,0,0,.05)}.box-empty{background:hsla(0,0%,100%,.3)}@media (max-width:374px){.box{width:28px;height:28px;font-size:20px}.keyboard{padding:4px}.keyboard-button{height:36px}.emojile-logo{margin:5px 0;width:100px;height:34px}}.leaderboardButtonBackground{background:linear-gradient(39deg,#ffba08 5.42%,#fec010 37.01%,#fae63c 103.46%)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
